export const financialGoalsQuestions = [
  {
    question: "1️⃣ What’s your main financial goal in the USA?",
    options: [
      { answer: "Save for a home", score: "home" },
      { answer: "Improve my credit score", score: "credit" },
      { answer: "Start a small business", score: "business" },
      { answer: "Send money back home regularly", score: "remittances" }
    ],
  },
  {
    question: "2️⃣ Are you currently employed or looking for a job?",
    options: [
      { answer: "Employed", score: "stable" },
      { answer: "Looking for a job", score: "jobsearch" }
    ],
  },
  {
    question: "3️⃣ Do you have a bank account in the USA?",
    options: [
      { answer: "Yes, checking or savings account", score: "banked" },
      { answer: "Not yet", score: "unbanked" }
    ],
  },
  {
    question: "4️⃣ How much can you save each paycheck?",
    options: [
      { answer: "$0 - $100", score: "low" },
      { answer: "$100 - $500", score: "medium" },
      { answer: "More than $500", score: "high" }
    ],
  }
];
